import { Route } from 'react-router-dom'

import { MarketShopPage } from '@/pages/market-shop'
import { MarketShopRestaurantPage } from '@/pages/market-shop-restaurant'

export const marketShopRoutesConfig = () => (
  <>
    <Route path="market-shop" element={<MarketShopPage />} />
    <Route path="market-shop/restaurant" element={<MarketShopRestaurantPage />} />
  </>
)
